const statusFormacaoEnum = {
    NAO_FINALIZADA: 1,
    AGUARDANDO_APROVACAO: 2,
    AGUARDANDO_APROVACAO_REAGENDAMENTO: 9,
    AGUARDANDO_CONSOLIDACAO: 3,
    AGUARDANDO_CONSOLIDACAO_REAGENDAMENTO: 10,
    PENDENTE_AJUSTE_APROVACAO : 5,
    PENDENTE_AJUSTE_CONSOLIDACAO : 7,
    REPROVADA_APROVACAO: 6,
    REPROVADA_CONSOLIDACAO: 8,
    CONSOLIDADA: 4,
    CONCLUIDA: 13,
    REALIZADA: 19,
};

export default statusFormacaoEnum ;